import { render, staticRenderFns } from "./ReceiptDialog.component.vue?vue&type=template&id=3de4f131&scoped=true"
import script from "./ReceiptDialog.component.vue?vue&type=script&lang=js"
export * from "./ReceiptDialog.component.vue?vue&type=script&lang=js"
import style0 from "./ReceiptDialog.component.vue?vue&type=style&index=0&id=3de4f131&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de4f131",
  null
  
)

export default component.exports